import React from 'react';
import classnames from 'classnames';
import {Button, Modal, Dialogue, Heading, Text, Icon} from '@albert-io/atomic';
import './assignment-builder-intro-modal.scss';

interface AssignmentBuilderIntroModalProps {
  handleClose: () => void;
}
export const assignmentBuilderLink =
  'https://www.youtube.com/embed/7B_gq7LJjHo?si=lDwQ8SI0rE1PSxRW&amp;';

const AssignmentBuilderIntroModal = ({handleClose}: AssignmentBuilderIntroModalProps) => {
  return (
    <Modal
      ariaLabel='Welcome to the assignment builder'
      handleClose={handleClose}
      backdropClassName='u-justify-content_center'
      fullscreen
    >
      {({CloseButtonWrapper, modalContentStyle}) => {
        return (
          <Dialogue
            hideCloseBtn
            inModal
            className={classnames(modalContentStyle, 'builder-intro-modal')}
            size='l'
          >
            <Dialogue.Body align='center' className='builder-intro-modal__body'>
              <div className='u-display_flex u-align-items_center u-flex-direction_column'>
                <div className='builder-intro-modal__heading-sparkles u-mar-b_1'>
                  <Icon className='u-mar-r_1' icon='sparkles' />
                  <Text color='inherit' bold>
                    Now In Beta
                  </Text>
                  <Icon className='u-mar-l_1' icon='sparkles' />
                </div>
                <div className='builder-intro-modal__heading-title-wrapper'>
                  <Heading>Assignment Builder</Heading>
                </div>
              </div>
              <Text className='u-mar-t_6 builder-intro-modal__body-text'>
                Quickly filter Albert&apos;s entire database by standard, subject, question type,
                and more!
              </Text>
              <Text className='u-mar-t_6 u-mar-b_3'>Watch our announcement video below:</Text>
              <iframe
                allowFullScreen
                className='builder-intro-modal__video'
                title='Assignment Builder Intro'
                src={assignmentBuilderLink}
              />
            </Dialogue.Body>
            <Dialogue.BtnGroup align='center' className=''>
              <CloseButtonWrapper>
                <Button data-test-id='AB-intro-modal__close-btn'>Get Started!</Button>
              </CloseButtonWrapper>
            </Dialogue.BtnGroup>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

export default AssignmentBuilderIntroModal;
